import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useAuth } from '../../../../../hooks/useAuth';
import { useEnv } from '../../../../../context/env-context';
import { makeRequest } from '../../../../../utils/makeRequest';
import { toast } from 'react-toastify';
import { CircularProgress } from '@mui/material';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkSlash, faEye } from '@fortawesome/free-solid-svg-icons';

function ConsumerFinchEmployeeIdForm({
  consumerId,
  consumerFinchConnectionId,
  consumerFinchEmployeeId,
  setConsumer,
  setEmployeeView,
}) {
  const [spinner, setSpinner] = useState(false);

  const { getAccessTokenSilently } = useAuth();
  const { apiOriginAggregator, apiOriginConsumer } = useEnv();

  const getFinchEmployee = async () => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginAggregator}/finch/employees`,
      method: 'POST',
      data: JSON.stringify({
        employees: [
          {
            finchConnectionId: consumerFinchConnectionId,
            finchEmployeeId: consumerFinchEmployeeId,
          },
        ],
      }),
    };

    try {
      const response = await makeRequest(config);

      setEmployeeView(response.employees[0]);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  };

  const unlinkEmployee = async () => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginConsumer}/unlink_employee`,
      method: 'POST',
      data: JSON.stringify({ consumerId }),
    };

    try {
      await makeRequest(config);

      setConsumer(prevConsumer => ({ ...prevConsumer, finchEmployeeId: null }));
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <>
      <Form.Label className="bo-common-input-label">Finch Employee ID</Form.Label>
      <div className="bo-common-text-input-container">
        <div className="w-100">
          <Form.Control
            className="bo-common-text-input"
            type="text"
            readOnly
            value={consumerFinchEmployeeId}
          />
          <div className="bo-common-text-bottom-border" />
        </div>
        <div
          className={classNames(
            'bo-common-input-button-container',
            spinner && 'bo-common-input-button-container-active',
          )}
        >
          {spinner ? (
            <div className="h-100">
              <CircularProgress color="inherit" size={16} />
            </div>
          ) : (
            <>
              <Button className="bo-common-input-button-icon" onClick={getFinchEmployee} key="view">
                <FontAwesomeIcon icon={faEye} color="#5946A4" size="1x" />
              </Button>
              <Button className="bo-common-input-button-icon" onClick={unlinkEmployee} key="unlink">
                <FontAwesomeIcon icon={faLinkSlash} color="#5946A4" size="1x" />
              </Button>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ConsumerFinchEmployeeIdForm;
